import {
	FETCH_INVENTAIRE_CONSOMMABLES_BEGIN,
	FETCH_INVENTAIRE_CONSOMMABLES_ERROR,
	FETCH_INVENTAIRE_CONSOMMABLES_RESET,
	FETCH_INVENTAIRE_CONSOMMABLES_SUCCESS,
	POST_INVENTAIRE_CONSOMMATION_BEGIN,
	POST_INVENTAIRE_CONSOMMATION_ERROR,
	POST_INVENTAIRE_CONSOMMATION_RESET,
	POST_INVENTAIRE_CONSOMMATION_SUCCESS,
	POST_INVENTAIRE_TRANSFERT_BEGIN,
	POST_INVENTAIRE_TRANSFERT_ERROR,
	POST_INVENTAIRE_TRANSFERT_RESET,
	POST_INVENTAIRE_TRANSFERT_SUCCESS,
	POST_INVENTAIRE_CORRECTION_BEGIN,
	POST_INVENTAIRE_CORRECTION_ERROR,
	POST_INVENTAIRE_CORRECTION_RESET,
	POST_INVENTAIRE_CORRECTION_SUCCESS,
	FETCH_LIENS_VIRTUELS_BEGIN,
	FETCH_LIENS_VIRTUELS_ERROR,
	FETCH_LIENS_VIRTUELS_SUCCESS,
	FETCH_INVENTAIRE_CATEGORIES_BEGIN,
	FETCH_INVENTAIRE_CATEGORIES_SUCCESS,
	FETCH_INVENTAIRE_CATEGORIES_ERROR,
	FETCH_INVENTAIRE_CATEGORIES_RESET,
	POST_INVENTAIRE_CATEGORIE_BEGIN,
	POST_INVENTAIRE_CATEGORIE_SUCCESS,
	POST_INVENTAIRE_CATEGORIE_ERROR,
	POST_INVENTAIRE_CATEGORIE_RESET,
	DELETE_INVENTAIRE_CATEGORIE_BEGIN,
	DELETE_INVENTAIRE_CATEGORIE_SUCCESS,
	DELETE_INVENTAIRE_CATEGORIE_ERROR,
	DELETE_INVENTAIRE_CATEGORIE_RESET,
	POST_INVENTAIRE_CONSOMMABLE_BEGIN,
	POST_INVENTAIRE_CONSOMMABLE_SUCCESS,
	POST_INVENTAIRE_CONSOMMABLE_ERROR,
	POST_INVENTAIRE_CONSOMMABLE_RESET,
	DELETE_INVENTAIRE_CONSOMMABLE_BEGIN,
	DELETE_INVENTAIRE_CONSOMMABLE_SUCCESS,
	DELETE_INVENTAIRE_CONSOMMABLE_ERROR,
	DELETE_INVENTAIRE_CONSOMMABLE_RESET,
	FETCH_INVENTAIRE_CONSOMMATIONS_BEGIN,
	FETCH_INVENTAIRE_CONSOMMATIONS_SUCCESS,
	FETCH_INVENTAIRE_CONSOMMATIONS_ERROR,
	PUT_INVENTAIRE_CONSOMMATION_BEGIN,
	PUT_INVENTAIRE_CONSOMMATION_SUCCESS,
	PUT_INVENTAIRE_CONSOMMATION_ERROR,
	PUT_INVENTAIRE_CONSOMMATION_RESET,
	DELETE_INVENTAIRE_CONSOMMATION_BEGIN,
	DELETE_INVENTAIRE_CONSOMMATION_SUCCESS,
	DELETE_INVENTAIRE_CONSOMMATION_ERROR,
	DELETE_INVENTAIRE_CONSOMMATION_RESET,
	FETCH_INVENTAIRE_CATEGORIES_TRI_BEGIN,
	FETCH_INVENTAIRE_CATEGORIES_TRI_SUCCESS,
	FETCH_INVENTAIRE_CATEGORIES_TRI_ERROR,
	FETCH_INVENTAIRE_CATEGORIES_TRI_RESET,
	FETCH_INVENTAIRE_FOURNISSEURS_BEGIN,
	FETCH_INVENTAIRE_FOURNISSEURS_SUCCESS,
	FETCH_INVENTAIRE_FOURNISSEURS_ERROR,
	FETCH_INVENTAIRE_FOURNISSEURS_RESET,
	POST_INVENTAIRE_FOURNISSEUR_BEGIN,
	POST_INVENTAIRE_FOURNISSEUR_SUCCESS,
	POST_INVENTAIRE_FOURNISSEUR_ERROR,
	POST_INVENTAIRE_FOURNISSEUR_RESET,
	DELETE_INVENTAIRE_FOURNISSEUR_BEGIN,
	DELETE_INVENTAIRE_FOURNISSEUR_SUCCESS,
	DELETE_INVENTAIRE_FOURNISSEUR_ERROR,
	DELETE_INVENTAIRE_FOURNISSEUR_RESET,
	FETCH_STOCK_VIRTUEL_BEGIN,
	FETCH_STOCK_VIRTUEL_ERROR,
	FETCH_STOCK_VIRTUEL_RESET,
	FETCH_STOCK_VIRTUEL_SUCCESS,
	FETCH_INVENTAIRE_VIRTUEL_COMMANDES_BEGIN,
	FETCH_INVENTAIRE_VIRTUEL_COMMANDES_SUCCESS,
	FETCH_INVENTAIRE_VIRTUEL_COMMANDES_ERROR,
	FETCH_INVENTAIRE_VIRTUEL_COMMANDES_RESET,
	MAJ_COMMANDE_VIRTUELLE,
	FETCH_INVENTAIRE_COMMANDES_BEGIN,
	FETCH_INVENTAIRE_COMMANDES_SUCCESS,
	FETCH_INVENTAIRE_COMMANDES_ERROR,
	FETCH_INVENTAIRE_COMMANDES_RESET,
	POST_INVENTAIRE_COMMANDE_BEGIN,
	POST_INVENTAIRE_COMMANDE_SUCCESS,
	POST_INVENTAIRE_COMMANDE_ERROR,
	POST_INVENTAIRE_COMMANDE_RESET,
	UPDATE_INVENTAIRE_COMMANDE_BEGIN,
	UPDATE_INVENTAIRE_COMMANDE_SUCCESS,
	UPDATE_INVENTAIRE_COMMANDE_ERROR,
	UPDATE_INVENTAIRE_COMMANDE_RESET,
	DELETE_INVENTAIRE_COMMANDE_BEGIN,
	DELETE_INVENTAIRE_COMMANDE_SUCCESS,
	DELETE_INVENTAIRE_COMMANDE_ERROR,
	DELETE_INVENTAIRE_COMMANDE_RESET,
	FETCH_INVENTAIRE_ARTICLES_BEGIN,
	FETCH_INVENTAIRE_ARTICLES_SUCCESS,
	FETCH_INVENTAIRE_ARTICLES_ERROR,
	FETCH_INVENTAIRE_ARTICLES_RESET,
	POST_INVENTAIRE_ARTICLE_BEGIN,
	POST_INVENTAIRE_ARTICLE_SUCCESS,
	POST_INVENTAIRE_ARTICLE_ERROR,
	POST_INVENTAIRE_ARTICLE_RESET,
	DELETE_INVENTAIRE_ARTICLE_BEGIN,
	DELETE_INVENTAIRE_ARTICLE_SUCCESS,
	DELETE_INVENTAIRE_ARTICLE_ERROR,
	DELETE_INVENTAIRE_ARTICLE_RESET,
	FETCH_INVENTAIRE_ALLARTICLES_BEGIN,
	FETCH_INVENTAIRE_ALLARTICLES_SUCCESS,
	FETCH_INVENTAIRE_ALLARTICLES_ERROR,
	FETCH_INVENTAIRE_ALLARTICLES_RESET,
	FETCH_INVENTAIRE_STOCK_VIRTUEL_BEGIN,
	FETCH_INVENTAIRE_STOCK_VIRTUEL_SUCCESS,
	FETCH_INVENTAIRE_STOCK_VIRTUEL_ERROR,
	FETCH_INVENTAIRE_STOCK_VIRTUEL_RESET,
	FETCH_INVENTAIRE_STOCK_BEGIN,
	FETCH_INVENTAIRE_STOCK_SUCCESS,
	FETCH_INVENTAIRE_STOCK_ERROR,
	FETCH_INVENTAIRE_STOCK_RESET,
	FETCH_MODAL_STOCK_BEGIN,
	FETCH_MODAL_STOCK_SUCCESS,
	FETCH_MODAL_STOCK_ERROR,
	FETCH_MODAL_STOCK_RESET,
	FETCH_MODAL_STOCK_VIRTUEL_BEGIN,
	FETCH_MODAL_STOCK_VIRTUEL_SUCCESS,
	FETCH_MODAL_STOCK_VIRTUEL_ERROR,
	FETCH_MODAL_STOCK_VIRTUEL_RESET,
	FETCH_MODAL_SUGGESTION_BEGIN,
	FETCH_MODAL_SUGGESTION_SUCCESS,
	FETCH_MODAL_SUGGESTION_ERROR,
	FETCH_MODAL_SUGGESTION_RESET,
	FETCH_INVENTAIRE_STOCK_TRI_BEGIN,
	FETCH_INVENTAIRE_STOCK_TRI_SUCCESS,
	FETCH_INVENTAIRE_STOCK_TRI_ERROR,
	FETCH_INVENTAIRE_STOCK_TRI_RESET,
	FETCH_INVENTAIRE_ARTICLEUSAGES_BEGIN,
	FETCH_INVENTAIRE_ARTICLEUSAGES_SUCCESS,
	FETCH_INVENTAIRE_ARTICLEUSAGES_ERROR,
	FETCH_INVENTAIRE_ARTICLEUSAGES_RESET,
	POST_INVENTAIRE_ARTICLEUSAGE_BEGIN,
	POST_INVENTAIRE_ARTICLEUSAGE_SUCCESS,
	POST_INVENTAIRE_ARTICLEUSAGE_ERROR,
	POST_INVENTAIRE_ARTICLEUSAGE_RESET,
	FETCH_INVENTAIRE_LIMITCHECKER_BEGIN,
	FETCH_INVENTAIRE_LIMITCHECKER_SUCCESS,
	FETCH_INVENTAIRE_LIMITCHECKER_ERROR,
	FETCH_STOCK_NON_DEBITE_COUNT_SUCCESS,
} from "../actions/atelierInventaireActions"

const initialState = {
	categories: [],
	articles: [],
	allArticles: [],
	articleUsages: [],
	articleUsagesHasMore: false,
	articleUsagesLoadingMore: false,
	stock: [],
	stockVirtuel: [],
	stockVirtuelHasMore: false,
	stockVirtuelLoadingMore: false,
	// Champs DÉDIÉS au modal AtelierInventaireModalV2 (paginés). Séparés des
	// champs stock/stockVirtuel ci-dessus pour ne pas perturber la page
	// inventaire / le modal legacy / l'éditeur de modèles.
	modalStock: [],
	modalStockHasMore: false,
	modalStockLoadingMore: false,
	fetchModalStock: { loading: false, error: false },
	modalStockVirtuel: [],
	modalStockVirtuelHasMore: false,
	modalStockVirtuelLoadingMore: false,
	fetchModalStockVirtuel: { loading: false, error: false },
	modalSuggestedCmds: [],
	fetchModalSuggestion: { loading: false, error: false },
	stockTri: [],
	commandes: [],
	commandesHasMore: false,
	commandesLoadingMore: false,
	commandesVirtuelles: [],
	commandesVirtuellesHasMore: false,
	commandesVirtuellesLoadingMore: false,
	fournisseurs: [],
	consommables: [],
	fetchConsommables: {
		loading: false,
		error: false,
	},
	postConsommable: {
		saved: false,
		saving: false,
		error: false,
	},
	deleteConsommable: {
		deleted: false,
		deleting: false,
		error: false,
	},
	consommations: [],
	fetchConsommations: {
		loading: false,
		error: false,
	},
	putConsommation: {
		saved: false,
		saving: false,
		error: false,
	},
	deleteConsommation: {
		deleted: false,
		deleting: false,
		error: false,
	},
	postConsommation: {
		saved: false,
		saving: false,
		error: false,
	},
	liensVirtuels: [],
	postTransfert: {
		saved: false,
		saving: false,
		error: false,
	},
	postCorrection: {
		saved: false,
		saving: false,
		error: false,
	},
	fetchCategories: {
		loading: false,
		error: false,
	},
	postCategorie: {
		saved: false,
		saving: false,
		error: false,
	},
	deleteCategorie: {
		deleted: false,
		deleting: false,
		error: false,
	},
	fetchArticles: {
		loading: false,
		error: false,
	},
	postArticle: {
		saved: false,
		saving: false,
		error: false,
	},
	deleteArticle: {
		deleted: false,
		deleting: false,
		error: false,
	},
	fetchAllArticles: {
		loading: false,
		error: false,
	},
	fetchArticleUsages: {
		loading: false,
		error: false,
	},
	postArticleUsages: {
		saved: false,
		saving: false,
		error: false,
	},
	fetchStock: {
		loading: false,
		error: false,
	},
	fetchStockVirtuel: {
		loading: false,
		error: false,
	},
	fetchStockTri: {
		loading: false,
		error: false,
	},
	fetchCommandesVirtuelles: {
		loading: false,
		error: false,
	},
	fetchCommandes: {
		loading: false,
		error: false,
	},
	postCommande: {
		saved: false,
		saving: false,
		error: false,
	},
	updateCommande: {
		saved: false,
		saving: false,
		error: false,
	},
	deleteCommande: {
		deleted: false,
		deleting: false,
		error: false,
	},
	fetchFournisseurs: {
		loading: false,
		error: false,
	},
	postFournisseur: {
		saved: false,
		saving: false,
		error: false,
	},
	deleteFournisseur: {
		deleted: false,
		deleting: false,
		error: false,
	},
	limitChecker: [],
	fetchLimitChecker: {
		loading: false,
		error: false,
	},
	lastCommandesKwargs: null,
	lastCommandesVirtuellesKwargs: null,
	lastStockVirtuelKwargs: null,
	lastArticleUsagesKwargs: null,
	stockNonDebite: 0,
}

export default function atelierInventaireReducer(state = initialState, action) {
	switch (action.type) {
		// POST CONSOMMATION
		case POST_INVENTAIRE_CONSOMMATION_BEGIN:
			return {
				...state,
				postConsommation: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_CONSOMMATION_ERROR:
			return {
				...state,
				postConsommation: {
					saved: false,
					saving: false,
					error: action.payload,
				},
			}
		case POST_INVENTAIRE_CONSOMMATION_SUCCESS:
			return {
				...state,
				stockVirtuel: action.payload,
				postConsommation: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_CONSOMMATION_RESET:
			return {
				...state,
				postConsommation: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// POST TRANSFERT STOCK VIRTUEL → STOCK PHYSIQUE
		case POST_INVENTAIRE_TRANSFERT_BEGIN:
			return {
				...state,
				postTransfert: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_TRANSFERT_ERROR:
			return {
				...state,
				postTransfert: {
					saved: false,
					saving: false,
					error: action.payload,
				},
			}
		case POST_INVENTAIRE_TRANSFERT_SUCCESS:
			return {
				...state,
				stockVirtuel: action.payload,
				postTransfert: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_TRANSFERT_RESET:
			return {
				...state,
				postTransfert: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// POST CORRECTION MANUELLE DU STOCK PHYSIQUE
		case POST_INVENTAIRE_CORRECTION_BEGIN:
			return {
				...state,
				postCorrection: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_CORRECTION_ERROR:
			return {
				...state,
				postCorrection: {
					saved: false,
					saving: false,
					error: action.payload,
				},
			}
		case POST_INVENTAIRE_CORRECTION_SUCCESS:
			// La réponse = liste stock fraîche (même forme que l'onglet Stock).
			return {
				...state,
				stock: action.payload,
				postCorrection: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_CORRECTION_RESET:
			return {
				...state,
				postCorrection: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// LIENS ARTICLE VIRTUEL → ARTICLE PHYSIQUE
		case FETCH_LIENS_VIRTUELS_BEGIN:
			return state
		case FETCH_LIENS_VIRTUELS_SUCCESS:
			return {
				...state,
				liensVirtuels: action.payload,
			}
		case FETCH_LIENS_VIRTUELS_ERROR:
			return state
		// FETCH CONSOMMABLES
		case FETCH_INVENTAIRE_CONSOMMABLES_BEGIN:
			return {
				...state,
				fetchConsommables: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_CONSOMMABLES_SUCCESS:
			return {
				...state,
				fetchConsommables: {
					loading: false,
					error: false,
				},
				consommables: action.payload,
			}
		case FETCH_INVENTAIRE_CONSOMMABLES_ERROR:
			return {
				...state,
				fetchConsommables: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_INVENTAIRE_CONSOMMABLES_RESET:
			return {
				...state,
				fetchConsommables: {
					loading: false,
					error: false,
				},
			}
		// CONSOMMABLE CRUD (Options → Stock virtuel) — la liste `consommables`
		// est rafraîchie via FETCH_INVENTAIRE_CONSOMMABLES_SUCCESS dispatché par
		// les thunks ; ici on ne gère que l'état du modal.
		case POST_INVENTAIRE_CONSOMMABLE_BEGIN:
			return {
				...state,
				postConsommable: { saved: false, saving: true, error: false },
			}
		case POST_INVENTAIRE_CONSOMMABLE_SUCCESS:
			return {
				...state,
				postConsommable: { saved: true, saving: false, error: false },
			}
		case POST_INVENTAIRE_CONSOMMABLE_ERROR:
			return {
				...state,
				postConsommable: { saved: false, saving: false, error: true },
			}
		case POST_INVENTAIRE_CONSOMMABLE_RESET:
			return {
				...state,
				postConsommable: { saved: false, saving: false, error: false },
			}
		case DELETE_INVENTAIRE_CONSOMMABLE_BEGIN:
			return {
				...state,
				deleteConsommable: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_CONSOMMABLE_SUCCESS:
			return {
				...state,
				deleteConsommable: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_CONSOMMABLE_ERROR:
			return {
				...state,
				deleteConsommable: {
					deleted: false,
					deleting: false,
					error: true,
				},
			}
		case DELETE_INVENTAIRE_CONSOMMABLE_RESET:
			return {
				...state,
				deleteConsommable: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// CONSOMMATIONS (liste / édition / suppression)
		case FETCH_INVENTAIRE_CONSOMMATIONS_BEGIN:
			return {
				...state,
				fetchConsommations: { loading: true, error: false },
			}
		case FETCH_INVENTAIRE_CONSOMMATIONS_SUCCESS:
			return {
				...state,
				fetchConsommations: { loading: false, error: false },
				consommations: action.payload,
			}
		case FETCH_INVENTAIRE_CONSOMMATIONS_ERROR:
			return {
				...state,
				fetchConsommations: { loading: false, error: true },
			}
		case PUT_INVENTAIRE_CONSOMMATION_BEGIN:
			return {
				...state,
				putConsommation: { saved: false, saving: true, error: false },
			}
		case PUT_INVENTAIRE_CONSOMMATION_SUCCESS:
			return {
				...state,
				consommations: action.payload,
				putConsommation: { saved: true, saving: false, error: false },
			}
		case PUT_INVENTAIRE_CONSOMMATION_ERROR:
			return {
				...state,
				putConsommation: { saved: false, saving: false, error: true },
			}
		case PUT_INVENTAIRE_CONSOMMATION_RESET:
			return {
				...state,
				putConsommation: { saved: false, saving: false, error: false },
			}
		case DELETE_INVENTAIRE_CONSOMMATION_BEGIN:
			return {
				...state,
				deleteConsommation: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_CONSOMMATION_SUCCESS:
			return {
				...state,
				consommations: action.payload,
				deleteConsommation: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_CONSOMMATION_ERROR:
			return {
				...state,
				deleteConsommation: {
					deleted: false,
					deleting: false,
					error: true,
				},
			}
		case DELETE_INVENTAIRE_CONSOMMATION_RESET:
			return {
				...state,
				deleteConsommation: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH CATEGORIES
		case FETCH_INVENTAIRE_CATEGORIES_BEGIN:
			return {
				...state,
				fetchCategories: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_CATEGORIES_SUCCESS:
			return {
				...state,
				fetchCategories: {
					loading: false,
					error: false,
				},
				categories: action.payload.categories,
			}
		case FETCH_INVENTAIRE_CATEGORIES_ERROR:
			return {
				...state,
				fetchCategories: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_CATEGORIES_RESET:
			return {
				...state,
				fetchCategories: {
					loading: false,
					error: false,
				},
			}
		// FETCH CATEGORIES TRI
		case FETCH_INVENTAIRE_CATEGORIES_TRI_BEGIN:
			return {
				...state,
				fetchCategoriesTri: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_CATEGORIES_TRI_SUCCESS:
			return {
				...state,
				fetchCategoriesTri: {
					loading: false,
					error: false,
				},
				categoriesTri: action.payload.categories,
			}
		case FETCH_INVENTAIRE_CATEGORIES_TRI_ERROR:
			return {
				...state,
				fetchCategoriesTri: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_CATEGORIES_TRI_RESET:
			return {
				...state,
				fetchCategoriesTri: {
					loading: false,
					error: false,
				},
			}
		// POST CATEGORIE
		case POST_INVENTAIRE_CATEGORIE_BEGIN:
			return {
				...state,
				postCategorie: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_CATEGORIE_ERROR:
			return {
				...state,
				postCategorie: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_INVENTAIRE_CATEGORIE_SUCCESS:
			return {
				...state,
				categories: action.payload.categories,
				postCategorie: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_CATEGORIE_RESET:
			return {
				...state,
				postCategorie: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// DELETE CATEGORIE
		case DELETE_INVENTAIRE_CATEGORIE_BEGIN:
			return {
				...state,
				deleteCategorie: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_CATEGORIE_ERROR:
			return {
				...state,
				deleteCategorie: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_INVENTAIRE_CATEGORIE_SUCCESS:
			return {
				...state,
				articles: [],
				categories: action.payload.categories,
				deleteCategorie: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_CATEGORIE_RESET:
			return {
				...state,
				deleteCategorie: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH FOURNISSEURS
		case FETCH_INVENTAIRE_FOURNISSEURS_BEGIN:
			return {
				...state,
				fetchFournisseurs: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_FOURNISSEURS_SUCCESS:
			return {
				...state,
				fetchFournisseurs: {
					loading: false,
					error: false,
				},
				fournisseurs: action.payload.fournisseurs,
			}
		case FETCH_INVENTAIRE_FOURNISSEURS_ERROR:
			return {
				...state,
				fetchFournisseurs: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_FOURNISSEURS_RESET:
			return {
				...state,
				fetchFournisseurs: {
					loading: false,
					error: false,
				},
			}
		// POST FOURNISSEUR
		case POST_INVENTAIRE_FOURNISSEUR_BEGIN:
			return {
				...state,
				postFournisseur: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_FOURNISSEUR_ERROR:
			return {
				...state,
				postFournisseur: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_INVENTAIRE_FOURNISSEUR_SUCCESS:
			return {
				...state,
				fournisseurs: action.payload.fournisseurs,
				postFournisseur: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_FOURNISSEUR_RESET:
			return {
				...state,
				postFournisseur: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// DELETE FOURNISSEUR
		case DELETE_INVENTAIRE_FOURNISSEUR_BEGIN:
			return {
				...state,
				deleteFournisseur: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_FOURNISSEUR_ERROR:
			return {
				...state,
				deleteFournisseur: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_INVENTAIRE_FOURNISSEUR_SUCCESS:
			return {
				...state,
				fournisseurs: action.payload.fournisseurs,
				deleteFournisseur: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_FOURNISSEUR_RESET:
			return {
				...state,
				deleteFournisseur: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH STOCK VIRTUEL
		case FETCH_STOCK_VIRTUEL_BEGIN:
			// append → page suivante (spinner bas de liste) ; sinon chargement
			// initial (spinner principal).
			return {
				...state,
				stockVirtuelLoadingMore: action.append,
				fetchStockVirtuel: {
					loading: !action.append,
					error: false,
				},
			}
		case FETCH_STOCK_VIRTUEL_SUCCESS:
			return {
				...state,
				fetchStockVirtuel: {
					loading: false,
					error: false,
				},
				stockVirtuelLoadingMore: false,
				stockVirtuelHasMore: action.hasMore,
				stockVirtuel: action.append
					? [...state.stockVirtuel, ...action.payload]
					: action.payload,
				lastStockVirtuelKwargs:
					action.kwargs || state.lastStockVirtuelKwargs,
			}
		case FETCH_STOCK_VIRTUEL_ERROR:
			return {
				...state,
				stockVirtuelLoadingMore: false,
				fetchStockVirtuel: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_STOCK_VIRTUEL_RESET:
			return {
				...state,
				fetchStockVirtuel: {
					loading: false,
					error: false,
				},
			}
		// MODAL — STOCK PHYSIQUE PAGINÉ
		case FETCH_MODAL_STOCK_BEGIN:
			return {
				...state,
				modalStockLoadingMore: action.append,
				fetchModalStock: {
					loading: !action.append,
					error: false,
				},
			}
		case FETCH_MODAL_STOCK_SUCCESS:
			return {
				...state,
				fetchModalStock: { loading: false, error: false },
				modalStockLoadingMore: false,
				modalStockHasMore: action.hasMore,
				modalStock: action.append
					? [...state.modalStock, ...action.payload]
					: action.payload,
			}
		case FETCH_MODAL_STOCK_ERROR:
			return {
				...state,
				modalStockLoadingMore: false,
				fetchModalStock: { loading: false, error: action.error },
			}
		case FETCH_MODAL_STOCK_RESET:
			return {
				...state,
				modalStock: [],
				modalStockHasMore: false,
				modalStockLoadingMore: false,
				fetchModalStock: { loading: false, error: false },
			}
		// MODAL — STOCK VIRTUEL PAGINÉ
		case FETCH_MODAL_STOCK_VIRTUEL_BEGIN:
			return {
				...state,
				modalStockVirtuelLoadingMore: action.append,
				fetchModalStockVirtuel: {
					loading: !action.append,
					error: false,
				},
			}
		case FETCH_MODAL_STOCK_VIRTUEL_SUCCESS:
			return {
				...state,
				fetchModalStockVirtuel: { loading: false, error: false },
				modalStockVirtuelLoadingMore: false,
				modalStockVirtuelHasMore: action.hasMore,
				modalStockVirtuel: action.append
					? [...state.modalStockVirtuel, ...action.payload]
					: action.payload,
			}
		case FETCH_MODAL_STOCK_VIRTUEL_ERROR:
			return {
				...state,
				modalStockVirtuelLoadingMore: false,
				fetchModalStockVirtuel: { loading: false, error: action.error },
			}
		case FETCH_MODAL_STOCK_VIRTUEL_RESET:
			return {
				...state,
				modalStockVirtuel: [],
				modalStockVirtuelHasMore: false,
				modalStockVirtuelLoadingMore: false,
				fetchModalStockVirtuel: { loading: false, error: false },
			}
		// MODAL — COMMANDE SUGGÉRÉE (par plaques)
		case FETCH_MODAL_SUGGESTION_BEGIN:
			return {
				...state,
				fetchModalSuggestion: { loading: true, error: false },
			}
		case FETCH_MODAL_SUGGESTION_SUCCESS:
			return {
				...state,
				fetchModalSuggestion: { loading: false, error: false },
				modalSuggestedCmds: action.payload,
			}
		case FETCH_MODAL_SUGGESTION_ERROR:
			return {
				...state,
				fetchModalSuggestion: { loading: false, error: action.error },
			}
		case FETCH_MODAL_SUGGESTION_RESET:
			return {
				...state,
				modalSuggestedCmds: [],
				fetchModalSuggestion: { loading: false, error: false },
			}
		// FETCH COMMANDES VIRTUELLES
		case FETCH_INVENTAIRE_VIRTUEL_COMMANDES_BEGIN:
			// append → page suivante (spinner bas de liste) ; sinon chargement
			// initial (spinner principal).
			return {
				...state,
				commandesVirtuellesLoadingMore: action.append,
				fetchCommandesVirtuelles: {
					loading: !action.append,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_VIRTUEL_COMMANDES_SUCCESS:
			return {
				...state,
				fetchCommandesVirtuelles: {
					loading: false,
					error: false,
				},
				commandesVirtuellesLoadingMore: false,
				commandesVirtuellesHasMore: action.hasMore,
				commandesVirtuelles: action.append
					? [...state.commandesVirtuelles, ...action.payload]
					: action.payload,
				lastCommandesVirtuellesKwargs:
					action.kwargs || state.lastCommandesVirtuellesKwargs,
			}
		case FETCH_INVENTAIRE_VIRTUEL_COMMANDES_ERROR:
			return {
				...state,
				commandesVirtuellesLoadingMore: false,
				fetchCommandesVirtuelles: {
					loading: false,
					error: action.payload,
				},
			}
		case MAJ_COMMANDE_VIRTUELLE:
			return {
				...state,
				commandesVirtuelles: state.commandesVirtuelles.map((c) =>
					c.id === action.payload.id ? action.payload : c,
				),
			}
		case FETCH_INVENTAIRE_VIRTUEL_COMMANDES_RESET:
			return {
				...state,
				fetchCommandesVirtuelles: {
					loading: false,
					error: false,
				},
			}
		// FETCH COMMANDES
		case FETCH_INVENTAIRE_COMMANDES_BEGIN:
			return {
				...state,
				commandesLoadingMore: action.append,
				fetchCommandes: {
					loading: !action.append,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_COMMANDES_SUCCESS:
			return {
				...state,
				fetchCommandes: {
					loading: false,
					error: false,
				},
				commandesLoadingMore: false,
				commandesHasMore: action.hasMore,
				commandes: action.append
					? [...state.commandes, ...action.payload.commandes]
					: action.payload.commandes,
				lastCommandesKwargs: action.kwargs || state.lastCommandesKwargs,
			}
		case FETCH_INVENTAIRE_COMMANDES_ERROR:
			return {
				...state,
				commandesLoadingMore: false,
				fetchCommandes: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_COMMANDES_RESET:
			return {
				...state,
				fetchCommandes: {
					loading: false,
					error: false,
				},
			}
		// POST COMMANDES
		case POST_INVENTAIRE_COMMANDE_BEGIN:
			return {
				...state,
				postCommande: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_COMMANDE_ERROR:
			return {
				...state,
				postCommande: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_INVENTAIRE_COMMANDE_SUCCESS:
			return {
				...state,
				commandes: action.payload.commandes,
				postCommande: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_COMMANDE_RESET:
			return {
				...state,
				postCommande: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// UPDATE COMMANDES
		case UPDATE_INVENTAIRE_COMMANDE_BEGIN:
			return {
				...state,
				updateCommande: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case UPDATE_INVENTAIRE_COMMANDE_ERROR:
			return {
				...state,
				updateCommande: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case UPDATE_INVENTAIRE_COMMANDE_SUCCESS:
			return {
				...state,
				commandes: action.payload.commandes,
				updateCommande: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case UPDATE_INVENTAIRE_COMMANDE_RESET:
			return {
				...state,
				updateCommande: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// DELETE COMMANDE
		case DELETE_INVENTAIRE_COMMANDE_BEGIN:
			return {
				...state,
				deleteCommande: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_COMMANDE_ERROR:
			return {
				...state,
				deleteCommande: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_INVENTAIRE_COMMANDE_SUCCESS:
			return {
				...state,
				commandes: action.payload.commandes,
				deleteCommande: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_COMMANDE_RESET:
			return {
				...state,
				deleteCommande: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH ARTICLES
		case FETCH_INVENTAIRE_ARTICLES_BEGIN:
			return {
				...state,
				fetchArticles: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_ARTICLES_SUCCESS:
			return {
				...state,
				fetchArticles: {
					loading: false,
					error: false,
				},
				articles: action.payload.articles,
			}
		case FETCH_INVENTAIRE_ARTICLES_ERROR:
			return {
				...state,
				fetchArticles: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_ARTICLES_RESET:
			return {
				...state,
				fetchArticles: {
					loading: false,
					error: false,
				},
			}
		// POST ARTICLES
		case POST_INVENTAIRE_ARTICLE_BEGIN:
			return {
				...state,
				postArticle: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_ARTICLE_ERROR:
			return {
				...state,
				postArticle: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_INVENTAIRE_ARTICLE_SUCCESS:
			return {
				...state,
				articles: action.payload.articles,
				postArticle: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_ARTICLE_RESET:
			return {
				...state,
				postArticle: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// DELETE ARTICLE
		case DELETE_INVENTAIRE_ARTICLE_BEGIN:
			return {
				...state,
				deleteArticle: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_ARTICLE_ERROR:
			return {
				...state,
				deleteArticle: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_INVENTAIRE_ARTICLE_SUCCESS:
			return {
				...state,
				articles: action.payload.articles,
				deleteArticle: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_INVENTAIRE_ARTICLE_RESET:
			return {
				...state,
				deleteArticle: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH ALLARTICLES
		case FETCH_INVENTAIRE_ALLARTICLES_BEGIN:
			return {
				...state,
				fetchAllArticles: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_ALLARTICLES_SUCCESS:
			return {
				...state,
				fetchAllArticles: {
					loading: false,
					error: false,
				},
				allArticles: action.payload.allArticles,
			}
		case FETCH_INVENTAIRE_ALLARTICLES_ERROR:
			return {
				...state,
				fetchAllArticles: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_ALLARTICLES_RESET:
			return {
				...state,
				fetchAllArticles: {
					loading: false,
					error: false,
				},
			}
		// FETCH STOCK VIRTUEL
		case FETCH_INVENTAIRE_STOCK_VIRTUEL_BEGIN:
			return {
				...state,
				fetchStockVirtuel: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_STOCK_VIRTUEL_SUCCESS:
			return {
				...state,
				fetchStockVirtuel: {
					loading: false,
					error: false,
				},
				stockVirtuel: action.payload,
			}
		case FETCH_INVENTAIRE_STOCK_VIRTUEL_ERROR:
			return {
				...state,
				fetchStockVirtuel: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_STOCK_VIRTUEL_RESET:
			return {
				...state,
				fetchStockVirtuel: {
					loading: false,
					error: false,
				},
			}
		// FETCH STOCK
		case FETCH_INVENTAIRE_STOCK_BEGIN:
			return {
				...state,
				fetchStock: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_STOCK_SUCCESS:
			return {
				...state,
				fetchStock: {
					loading: false,
					error: false,
				},
				stock: action.payload.stock,
			}
		case FETCH_INVENTAIRE_STOCK_ERROR:
			return {
				...state,
				fetchStock: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_STOCK_RESET:
			return {
				...state,
				fetchStock: {
					loading: false,
					error: false,
				},
			}
		// FETCH STOCK TRI
		case FETCH_INVENTAIRE_STOCK_TRI_BEGIN:
			return {
				...state,
				fetchStockTri: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_STOCK_TRI_SUCCESS:
			return {
				...state,
				fetchStockTri: {
					loading: false,
					error: false,
				},
				stockTri: action.payload.stock,
			}
		case FETCH_INVENTAIRE_STOCK_TRI_ERROR:
			return {
				...state,
				fetchStockTri: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_STOCK_TRI_RESET:
			return {
				...state,
				fetchStockTri: {
					loading: false,
					error: false,
				},
			}
		// FETCH ARTICLEUSAGES
		case FETCH_INVENTAIRE_ARTICLEUSAGES_BEGIN:
			return {
				...state,
				articleUsagesLoadingMore: action.append,
				fetchArticleUsages: {
					loading: !action.append,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_ARTICLEUSAGES_SUCCESS:
			return {
				...state,
				fetchArticleUsages: {
					loading: false,
					error: false,
				},
				articleUsagesLoadingMore: false,
				articleUsagesHasMore: action.hasMore,
				articleUsages: action.append
					? [...state.articleUsages, ...action.payload.articleUsages]
					: action.payload.articleUsages,
				lastArticleUsagesKwargs:
					action.kwargs || state.lastArticleUsagesKwargs,
			}
		case FETCH_INVENTAIRE_ARTICLEUSAGES_ERROR:
			return {
				...state,
				articleUsagesLoadingMore: false,
				fetchArticleUsages: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_INVENTAIRE_ARTICLEUSAGES_RESET:
			return {
				...state,
				fetchArticleUsages: {
					loading: false,
					error: false,
				},
			}
		// POST ARTICLEUSAGES
		case POST_INVENTAIRE_ARTICLEUSAGE_BEGIN:
			return {
				...state,
				postArticleUsage: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_INVENTAIRE_ARTICLEUSAGE_ERROR:
			return {
				...state,
				postArticleUsage: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_INVENTAIRE_ARTICLEUSAGE_SUCCESS:
			return {
				...state,
				// articles: action.payload.articles,
				postArticleUsage: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_INVENTAIRE_ARTICLEUSAGE_RESET:
			return {
				...state,
				postArticleUsage: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// FETCH LIMITECHECKER
		case FETCH_INVENTAIRE_LIMITCHECKER_BEGIN:
			return {
				...state,
				fetchLimitChecker: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_LIMITCHECKER_SUCCESS:
			return {
				...state,
				limitChecker: action.payload.limitChecker.limitChecker,
				fetchLimitChecker: {
					loading: true,
					error: false,
				},
			}
		case FETCH_INVENTAIRE_LIMITCHECKER_ERROR:
			return {
				...state,
				fetchLimitChecker: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_STOCK_NON_DEBITE_COUNT_SUCCESS:
			return { ...state, stockNonDebite: action.payload }
		default:
			return state
	}
}
